import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useForm } from "react-hook-form";
import { Box, Divider, InputLabel, TextField, Typography } from "@mui/material";
import DataBlock from "../../../../../shared/components/dataBlocks/DataBlock";
import { integerRegex } from "../../../../../shared/validators";
import {
  ChangeBuyerStockItemModel,
  ProductAvailabilityCode
} from "../../../../shared/models/customerBuyerStockItemsModels";
import moment from "moment";
import { Offer } from "../../../../shared/models/customerMyOffersModel";
import { calculateTotalPrice } from "../../../../../shared/models/models";
import { dt } from "../../../../../shared/themes/redesignTokens";

interface StockItemDetailsAdditionalProps {
  offer: Offer;
  className: string;
}

const Additional = ({ offer, className }: StockItemDetailsAdditionalProps) => {
  const {
    register,
    unregister,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<ChangeBuyerStockItemModel>();

  const deliveryTerm = (): any => {
    if (!offer?.availabilityCode) {
      return;
    }

    switch (offer?.availabilityCode) {
      case ProductAvailabilityCode.inStock:
        return moment().format("D.M.yyyy");
      case ProductAvailabilityCode.in7Days:
        return moment().add(7, "d").format("D.M.yyyy");
      case ProductAvailabilityCode.in14Days:
        return moment().add(14, "d").format("D.M.yyyy");
      case ProductAvailabilityCode.in1Month:
        return moment().add(1, "M").format("D.M.yyyy");
    }
  };

  const [quantity, setQuantity] = useState<number>();

  const handleChange = (event: any) => {
    setQuantity(Number(event.target.value));
  };

  useEffect(() => {
    unregister("quantity");
  }, [offer.id]);

  return (
    <Box>
      <Box className="mt-4 mb-4">
        <InputLabel>Quantity</InputLabel>

        <Box component="form" className="flex gap-4 mt-2">
          <TextField
            key={offer.id}
            type="number"
            className="w-full"
            {...register("quantity", {
              required: "Field is required",
              value: offer.quantity,
              pattern: { value: integerRegex, message: "Invalid value" }
            })}
            onChange={(event: any) => handleChange(event)}
            InputProps={{ inputProps: { min: 1 } }}
            error={!!errors.quantity}
            helperText={errors.quantity?.message}
          />

          <Box className="text-end" sx={{ minWidth: "120px" }}>
            <InputLabel sx={{ textTransform: "none !important", fontWeight: "400 !important" }}>Item total</InputLabel>
            <Typography fontSize={14} fontWeight={500} className="text-14-medium" style={{ color: "#333" }}>
              <NumericFormat
                value={calculateTotalPrice(offer?.unitPrice?.value, offer?.quantity)}
                displayType="text"
                thousandSeparator=" "
                suffix="€"
              />
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider></Divider>

      <Box className="mt-6">
        <Box className="flex justify-between items-center gap-4">
          <Typography fontSize={16} fontWeight={600} className="text-16-bold" style={{ color: "#333" }}>
            Total
          </Typography>
          <Typography fontSize={24} fontWeight={500} className="heading-2" style={{ color: dt.blue }}>
            <NumericFormat value={calculateTotalPrice(offer?.unitPrice?.value, offer?.quantity)} displayType="text" thousandSeparator=" " suffix="€" />
          </Typography>
        </Box>

        <Box className="flex justify-between items-center gap-4">
          <Typography fontSize={16} fontWeight={600} className="text-16-bold">
            Estimated delivery date
          </Typography>

          <Typography fontSize={16} fontWeight={400} className="text-16-regular">
            {deliveryTerm()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Additional;
